mutation ConnectTableOrder($orderId: ID!, $code: String!) {
  connectTableOrder(input: { orderId: $orderId, code: $code }) {
    order {
      id
      status
    }
    errors
  }
}